<template>
  <nav class="container-fluid Navbar">

    <!-- mobile menu -->
    <transition name="slideIn">
      <div class="Navbar-menu Navbar-menu--mobile d-lg-none" v-if="isOpen"
      :style="{ backgroundImage: 'url(./static/images/' + 'navbar-bg.jpg' + ')' }">
        <ul class="Navbar-menu-list Navbar-menu-list--mobile">
            <li @click="toggleMenu"><router-link to="/">Intro</router-link></li>
            <li @click="toggleMenu"><router-link to="/wolves-101">Wolves 101</router-link></li>
            <li @click="toggleMenu"><router-link to="/explore-the-wolf">Explore the Wolf</router-link></li>
            <li @click="toggleMenu"><router-link to="/ecosystem">Ecosystem</router-link></li>
            <li @click="toggleMenu"><router-link to="/about">About</router-link></li>
            <li @click="toggleMenu"><router-link to="/take-action">Take Action</router-link></li>
            <li @click="toggleMenu"><a href="https://livingwithwolves.org">Home</a></li>
        </ul>
      </div>
    </transition>

    <div class="container">
      <div class="row">
        <!-- logo -->
        <div class="col-8 col-sm-6 col-lg-3 col-xl-3 pr-xl-5">
          <a href="https://livingwithwolves.org">
            <img src="./../../../static/images/lww-logo.png" alt="Living with Wolves">
          </a>
        </div>
        <!-- nav menu -->
        <div class="col-4 col-sm-6 col-lg-9 col-xl-8 ml-auto Navbar-menu">

          <!-- mobile menu toggle -->
          <div class="Navbar-menu-toggle d-lg-none" @click="toggleMenu()">
            <transition name="fade" mode="out-in">
              <icon name="bars" scale="1.5" v-if="!isOpen" :key="'open'"></icon>
              <icon name="close" scale="1.5" v-else :key="'close'"></icon>
            </transition>
          </div>

          <!-- desktop nav menu -->
          <div class="Navbar-menu Navbar-menu--desktop d-none d-lg-flex">
            <ul class="Navbar-menu-list Navbar-menu-list--desktop">
              <li><router-link to="/">Intro</router-link></li>
              <li><router-link to="/wolves-101">Wolves 101</router-link></li>
              <li><router-link to="/explore-the-wolf">Explore the Wolf</router-link></li>
              <li><router-link to="/ecosystem">Ecosystem</router-link></li>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/take-action">Take Action</router-link></li>
              <li><a href="https://livingwithwolves.org">Home</a></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import siteConfig from './../../../static/data/site-config.json'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/close'
export default {
  components: {
    Icon
  },

  data () {
    return {
      siteConfig,
      isOpen: false
    }
  },

  computed: {
    currentRoute () {
      return this.$route.path
    },
    currentRouteIsHome () {
      return this.$route.path === '/'
    }
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    },

    updateAndClose (link, animation) {
      this.toggleMenu()
      this.updateState(link, animation)
    },

    updateState (link, animation) {
      let parent = link.defaultView.parent
      let view = link.defaultView.view
      let payload = {
        parent: parent,
        updates: {
          currentDetail: null,
          currentView: view,
          animation: animation || 'fade'
        }
      }
      if (parent && view !== '') {
        this.$store.dispatch('updateProps', payload)
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import "./../../assets/_variables.scss";
img {
  max-width: 100%;
}

.Navbar {
  align-items: center;
  background: #000;
  border-top: 2px solid $gold;
  color: #f2f2f2;
  display: flex;
  position: fixed;
  height: $navBarHeight;
  z-index: 10;
}

.Navbar-menu {
  align-items: center;
  display: flex;
  font-family: $fontSansSerif;
  font-size: .95rem;
  justify-content: flex-end;
  letter-spacing: .025em;
  text-transform: uppercase;
}

.Navbar-menu--desktop {
  width: 100%;
}

.Navbar-menu--mobile {
  background-color: black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 78px;
  width: 100vw;
  height: 100vh;
}

.Navbar-menu-list {
  align-items: center;
  display: flex;
  list-style-type: none;
  padding: 0;
  width: 100%;
}

.Navbar-menu-list--desktop {
  font-size: .85em;
  justify-content: space-between;
  margin: 0;
  height: 100%;
  a {
    transition: $transitionHover;
    &:hover {
      color: $gold;
    }
  }
}

.Navbar-menu-list--mobile {
  color: $offwhite;
  flex-direction: column;
  margin: 0;
  padding: .5em 0;
  height: 100%;
  width: 100%;
  & li {
    background-color: $transparentGray;
    font-size: 1.25em;
    margin-top: .5em;
    padding: .25em 1em;
  }
}

.Navbar-menu-toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.router-link-exact-active {
  color: $gold;
  position: relative;
  &::after {
    background-color: $gold;
    content: '';
    position: absolute;
    bottom: -.5em;
    left: 0;
    transition: $transitionHover;
    width: 100%;
    height: 2px;
  }
  &:hover:after {
    height: 4px;
  }
}

.router-link--hide {
  &::after {
    display: none;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/partials/navbar.vue